<!-- <div class="w3-col m8 w3-container w3-margin-bottom info-container2 w3-center w3-hover-shadow w3-borderB"> -->
  <h5 style="color:rgb(22, 21, 21); background:darkseagreen;" class="px-3"><b>Projects Under
      Pipeline</b></h5>
  <p style="font-size:14px; margin-left:15px; margin-right:10px; color:black; text-align: justify;"><b>
      a) Projects submitted by CADA to
      Government of India, Ministry of Water Resources, RD&amp;GR, New Delhi for inclusion under the
      umbrella
      scheme of PMKSY - HKKP - ISBIG.</b></p>
  <p style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;">
    <b><strong>Pradhan Mantri
        Krishi Sinchayee Yojana (PMKSY)</strong> scheme is a Centrally Sponsored flagship scheme of
      Government of
      India. The GoI decided in December, 2016 to take up Command Area Development and Water Management
      (CADWM) works under the newly introduced scheme namely
      ‘Incentivization Scheme for Bridging the Irrigation Gap (ISBIG) under the umbrella scheme of
      PMKSY-HKKP.
      Haryana state has prepared and submitted 6 projects
      pertaining to CADWM Works to the concerned Ministry in GOI i.e. MOWR, RD&GR. The projects are under
      active consideration with GOI. As soon as approval is
      received from the GOI the same shall be implemented in Haryana State. The main objectives of the
      scheme
      are as under:-<br>
      (a) Completion of CADWM works along with correction of system deficiencies in canal network for
      bridging
      the gap between Irrigation Potential Created (IPC)<br>
      and Irrigation Potential Utilized (IPU).<br>
      (b) Improving the water use efficiency in irrigation and providing assured supply of water to every
      farm
      field; and<br>
      (c) Transfer of control and management of irrigation system to the Water Users’ Associations
      (WUAs).</b><br><br>

    <strong>The details of the projects submitted to GoI, MoWR for approval and inclusion under ISBIG are as
      under:-</strong><br>
  </p>

  <table class="w3-border" style="border-collapse:separate; margin-left:40px; width:90%;">
    <tr>
      <th>Sr.No.</th>
      <th>Name of Projects</th>
      <th>Physical Target(CCA in Ha.)</th>
      <th>
        Estimated cost of the Project(Rs. in lakh)</th>
      <th>Districts to be covered</th>
    </tr>
    <tr>
      <th colspan=5>A On-going Projects</th>
    </tr>
    <tr>
      <td>1</td>
      <td>BCC-II </td>
      <td>1,07,675 </td>
      <td>72984.18 </td>
      <td>Hisar, Sirsa,
        Fatebahad, Ambala, Kaithal, Kanal, Kurukshetra &amp; Jind</td>
    </tr>
    <tr>
      <td>2</td>
      <td>WJC-VI</td>
      <td>73,144</td>
      <td>49238.55</td>
      <td>
        Hisar, Rohtak, Jhajjar, Sonepat, Jind, Bhiwani &amp; Panipat</td>
    </tr>
    <tr>
      <td>3</td>
      <td>JLN-II</td>
      <td>88,704</td>
      <td>59495.00</td>
      <td>Jhajjar,
        Rewari, Mehandergarh, Bhiwani &amp; Gurgaon</td>
    </tr>
    <tr>
      <th colspan=5>B New Projects</th>
    </tr>
    <tr>
      <td>4</td>
      <td>BCC-III</td>
      <td>1,71,852</td>
      <td>111141.06</td>
      <td>Hisar,
        Sirsa, Fatebahad, Ambala, Kaithal, Kanal, Kurukshetra &amp; Jind</td>
    </tr>
    <tr>
      <td>
        5</td>
      <td>WJC-VII</td>
      <td>75,341</td>
      <td>49567.71</td>
      <td>Hisar, Rohtak,
        Jhajjar, Sonepat, Jind, Bhiwani &amp; Panipat</td>
    </tr>
    <tr>
      <td>6</td>
      <td>Siwani Project </td>
      <td>49,899</td>
      <td>31834.95</td>
      <td>
        Bhiwani</td>
    </tr>
    <tr>
      <td colspan=2>Total</td>
      <td>5,66,615</td>
      <td>374261.45</td>
      <td>NA</td>
    </tr>
  </table><br>


  <p style="font-size:14px; margin-left:15px; margin-right:10px; color:black; text-align: justify;">
    <b><strong>b)
        Micro Irrigation Projects under Micro Irrigation Fund - NABARD</strong><br></b>
  </p>
  <p style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;">
    <b>i) Project for Installation of Community Based Solar/Grid Powered Integrated Micro Irrigation
      Infrastructure with On-Farm Micro Irrigation in
      existing canal commands in various districts of Haryana under NABARD<br>
      To promote micro irrigation system in the fields of farmers, CADA has prepared a micro irrigation
      project with an estimated cost of Rs 189.46 crore for
      bringing 9022 hectares CCA of 13 districts namely Hisar, Fatehabad, Sirsa, Bhiwani, Kaithal, Karnal,
      Kurukshetra, Sonipat, Rohtak, Jhajjar, Jind, Rewari
      and Mahendragarh under Micro Irrigation Fund - NABARD. This project has already been approved by the
      State Government and NABARD. Work on this project will
      be started shortly.</b>
  </p>
  <p style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;"><b>
      ii) Project for installation of Community Based Solar/ Grid
      Powered Micro-Irrigation Infrastructure in Kheri Distributory of Fatehabad, Hisar &amp;
      Sirsa districts of Haryana under PPP Mode.<br>
      CADA has also prepared another micro irrigation project under PPP Mode with an estimated cost of Rs
      399.97 crore. Under this project, 22941 hectares CCA
      of Hisar, Fatehabad and Sirsa districts will be brought under micro irrigation. This project has
      already
      been approved by the State Government and NABARD.
      Work on this project will be started shortly.</b></p><br>

<!-- </div> -->